import { EventBusForThirdParty } from '../event-bus'
import { handleProductDetailViewEventForGA4 } from './default/handle-product-detail-view'
import { handlePublishDeveloperReports } from './default/handle-publish-developer-reports'
import { EventSubscriptionFacade } from './facade'
import { handleAddToCart } from './ledian/handle-add-to-cart'
import { handleAddToFavorite } from './ledian/handle-add-to-favorite'
import { handleEveryPageView } from './ledian/handle-every-page-view'
import { handlePurchase } from './ledian/handle-purchase'
import { handleSubscribeMembershipPlan } from './ledian/handle-subscribe-membership-plan'
import { handleCartViewEvent } from './shared/handle-cart-detail-view'
import { handleLoginEvent } from './shared/handle-login'
import { handleProductDetailViewEvent } from './shared/handle-product-detail-view'
import { handleSignupEvent } from './shared/handle-signup'

export class LedianEventSubscriptionFacade implements EventSubscriptionFacade {
  constructor() {
    /** GAで使用するdataLayerがundefinedでないことを保証する。 */
    window.dataLayer = window.dataLayer || []
  }

  subscribeAll(): void {
    const eventBus = EventBusForThirdParty.getInstance()
    eventBus.subscribe('signup', handleSignupEvent)
    eventBus.subscribe('every-page-view', handleEveryPageView)
    eventBus.subscribe('product-detail-view', handleProductDetailViewEvent)
    eventBus.subscribe('product-detail-view', handleProductDetailViewEventForGA4)
    eventBus.subscribe('cart-view', handleCartViewEvent)
    eventBus.subscribe('login', handleLoginEvent)
    eventBus.subscribe('add-to-favorite', handleAddToFavorite)
    eventBus.subscribe('add-to-cart', handleAddToCart)
    eventBus.subscribe('purchase', handlePurchase)
    eventBus.subscribe('subscribe-membership-plan', handleSubscribeMembershipPlan)
    eventBus.subscribe('publish-developer-reports', handlePublishDeveloperReports)
  }
}
